class Answer {

    constructor() {

        this.answeredPollUsers = []
    }

    sanitizePollAnswer(result, answers, questionIndex) {

        var users = [],
            sinitized = [],
            answerScore = {},
            sum = 0

        result = result.filter(function (res) {
            return res.questionIndex == questionIndex
        })

        result.forEach(function (res) {

            if (users.indexOf(res.name) == -1) {

                sinitized.push(res)
                users.push(res.name)

                if (!answerScore['answer_' + res.answerIndex]) {
                    answerScore['answer_' + res.answerIndex] = 0
                }

                if (res.answerIndex != -1) {
                    answerScore['answer_' + res.answerIndex] = answerScore['answer_' + res.answerIndex] + 1
                }
            }
        })

        this.answeredPollUsers = users

        for (var answer in answerScore) {
            sum += answerScore[answer]
        }

        answers.forEach(function (answer, index) {

            var score = answerScore['answer_' + index] == undefined ? 0 : parseInt(answerScore['answer_' + index])
            answers[index].score = (score * 100) / sum
        }.bind(this))

        return answers
    }

    getPollAnsweredUsers() {

        return this.answeredPollUsers.length
    }

    summarizePollAnswer(result, questions) {

        var userAnsweredQuestions = {},
            summary = []

        result.forEach(function (res) {

            if (!userAnsweredQuestions['question_' + res.questionIndex]) {
                userAnsweredQuestions['question_' + res.questionIndex] = {
                    questionIndex: res.questionIndex,
                    result: []
                }
            }

            userAnsweredQuestions['question_' + res.questionIndex].result.push(res.answerIndex[0])
        })

        for (var userAnswerQuestion in userAnsweredQuestions) {

            userAnsweredQuestions[userAnswerQuestion]['selected'] = this.countPollResult(userAnsweredQuestions[userAnswerQuestion].result)
        }

        questions.forEach(function (question, index) {

            let image = ""
            let title = ""

            if (question.answers[userAnsweredQuestions['question_' + index].selected]) {
                image = question.answers[userAnsweredQuestions['question_' + index].selected].image
                title = question.answers[userAnsweredQuestions['question_' + index].selected].title
            }

            summary.push({
                title: question.title,
                questionImage: question.image,
                image: image,
                mostSelected: title
            })
        })

        return summary
    }

    isAllImageAnswer(answers) {

        var hasImages = 0

        answers.forEach(function (answer) {

            if (answer.image.length) {
                hasImages++
            }
        })

        return hasImages == answers.length
    }

    countPollResult(result) {
        let counts = {}

        result = result.filter(data => data !== undefined)

        result.forEach(name => counts[name] ? counts[name] ++ : counts[name] = 1);

        let max = Math.max(...Object.values(counts));

        let highest = Object.entries(counts).filter(([name, reps]) => reps === max);

        return parseInt(highest[0])
    }

    sanitizeQuizAnswer(result, questionIndex) {

        return result.filter(function (res) {
            return res.questionIndex == questionIndex
        })
    }

    sanitizeQuizOverallAnswer(result) {

        return result
    }

    getCurrentPlayerResult(result, playerName) {

        var playerIndex = result.findIndex(function(player) {
            return player.name == playerName
        })

        if (!result[playerIndex]) {
            return false
        }

        return result[playerIndex].result
    }

    average(member) {

        var total = 0

        for (var i = 0; i < member.length; i++) {
            total += Number(member[i])
        }


        return Math.ceil(total / member.length)
    }

    summarizeQuiz(result, joinedPlayers) {

        var playerResult = {},
            players = []

        joinedPlayers.forEach(function (player) {

            if (!playerResult[player]) {
                playerResult[player] = {
                    name: player,
                    score: 0,
                    timers: []
                }
            }
        })

        result.forEach(function (res) {

            if (typeof playerResult[res.name] !== 'undefined') {
                playerResult[res.name].score += res.result ? 1 : 0
                playerResult[res.name].timers.push(res.timer)
            }
        })

        for (var player in playerResult) {

            players.push({
                name: playerResult[player].name,
                score: playerResult[player].score,
                timer: this.average(playerResult[player].timers)
            })
        }

        return this.sortQuizResult(players)
    }

    sortQuizResult(players) {

        var sorter = function (fields) {
            return function (a, b) {
                return fields
                    .map(function (o) {
                        var dir = 1;
                        if (o[0] === '-') {
                            dir = -1;
                            o = o.substring(1);
                        }
                        if (a[o] > b[o]) return dir;
                        if (a[o] < b[o]) return -(dir);
                        return 0;
                    })
                    .reduce(function firstNonZeroValue(p, n) {
                        return p ? p : n;
                    }, 0);
            };
        }

        return players.sort(sorter(['-score', 'timer']));
    }
}

export default new Answer
